// Static site media (logo, packaging photos, banners, QR, seed photos) now
// live in Cloudflare R2 under the site-assets/ prefix instead of frontend/public.
// They were uploaded by the admin-migrate-site-assets-to-r2 Edge Function.
//
// asset("brand/logo.webp") -> https://<r2-public>/site-assets/brand/logo.webp
//
// Override the base at build time with REACT_APP_SITE_ASSETS_BASE if the R2
// public URL ever changes, so we never have to touch call sites again.

const SITE_ASSETS_BASE_RAW =
  process.env.REACT_APP_SITE_ASSETS_BASE ||
  "https://pub-943b75e7b18343e1bb8dac2cc6d593f0.r2.dev/site-assets";

export const SITE_ASSETS_BASE = SITE_ASSETS_BASE_RAW.replace(/\/+$/, "");

export const asset = (relPath) =>
  `${SITE_ASSETS_BASE}/${String(relPath || "").replace(/^\/+/, "")}`;
